/**
 * Ad Slots Module
 * Handles Ad Slot configurations and definitions
 * version 2.1.1
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('AdModules/adslots',[
    "jquery",
    "logging",
    "utilities",
    "AdModels/AdSlot"
], function($, logging, utilities, AdSlot) {
    "use strict";

    var _ModuleName = "Ad Slot Module";

    var _config = { };
    var _data = {
        pageconfig: { }
    }

    var init = function( config ) {
        $.extend(_config, config.adslots);
    }

    var start = function( pageconfig ) {
        _data.pageconfig = pageconfig;
    }

    /**
     * Define Page Slot for DFP
     * @param {AdSlot} slot Ad Slot object
     */
    var definePageSlot = function ( slot ) {
        if(typeof(slot) == 'undefined') {
            logging.error("Invalid Slot Configuration, unable to define slot. {id: " + slot.id + ", position: " + slot.position + "}", _ModuleName);
            return;
        }
        if(typeof(_data.pageconfig) == 'undefined') {
            logging.error("Invalid Page Configuration, unable to define slot {id: " + slot.id + ", position: " + slot.position + "}", _ModuleName);
            return;
        }

        ;
        // If slot is marked fluid, add to eligible sizes
        var slotDef = window.googletag.defineSlot(_data.pageconfig.hierarchy, slot.sizes, slot.id);
        if ($(slotDef).length) {
            ;
            if(_data.pageconfig.fluid.enabled && slot.fluid) { slot.sizes.push(_data.pageconfig.fluid.size); }
            var map = _getSizeMapping(slot);
            slotDef.addService(window.googletag.pubads())
                .defineSizeMapping(map)
                .setCollapseEmptyDiv(true)
                .setSafeFrameConfig({sandbox:true})
                .setTargeting("pos", slot.position)
                .setTargeting("vtier", slot.vtier)
                .setTargeting("roadblock", slot.roadblock);
            slot.def = slotDef;
        } else {
            logging.error("Failed to define Slot. Definition is empty. {id: " + slot.id + ", position: " + slot.position + "}", _ModuleName);
        }
    }

    /**
     * Define out of page slot for DFP
     * @param {AdSlot} slot Ad slot object
     */
    var defineOutOfPageSlot = function ( slot ) {
        if(typeof(slot) == 'undefined') {
            logging.error("Invalid Slot Configuration, unable to define slot.", _ModuleName);
            return;
        }
        if(typeof(_data.pageconfig) == 'undefined') {
            logging.error("Invalid Page Configuration, unable to define slot", _ModuleName);
            return;
        }

        ;
        var slotDef = window.googletag.defineOutOfPageSlot(_data.pageconfig.hierarchy, slot.id);
        if(_data.pageconfig.fluid.enabled && slot.fluid) { slot.sizes.push(p_data.ageconfig.fluid.size); }
        var map = _getSizeMapping(slot);
        if ($(slotDef).length) {
            slotDef.addService(window.googletag.pubads())
                .defineSizeMapping(map)
                .setCollapseEmptyDiv(true)
                .setTargeting("pos", slot.position);
            slot.def = slotDef;
        } else {
            logging.error("Failed to define Out of Page Slot : " + JSON.stringify(slot), _ModuleName);
        }
    }

    /**
     * Initialize an Ad Slot Object
     * @param {*} config Ad slot configuration object
     */
    var initAdSlot = function( config ) {
        var slot = new AdSlot( config );

        // Set display based on mobile flag until back-end is updated
        slot.display = slot.mobile ? _config.displaymaps.XTRASMALL : _config.displaymaps.SMALL;

        return slot;
    }

    /**
     * Builds size mapping to pass to DFP slot definition
     * @param {AdSlot} slot Ad slot object
     */
    var _getSizeMapping = function( slot ) {
        var map = window.googletag.sizeMapping();

        for(var m in _config.displaymaps) {
            map.addSize(_config.displaymaps[m], slot.display == _config.displaymaps[m] ? slot.sizes : []);
        }

        return map.build();
    }

    return {
        init: init,
        start: start,
        definePageSlot: definePageSlot,
        defineOutOfPageSlot: defineOutOfPageSlot,
        initAdSlot: initAdSlot
    }
});
